const clearFiltersButton = document.getElementById('clear-filters');

if (clearFiltersButton) {
	clearFiltersButton.addEventListener('click', () => {
		// Get all select elements inside the form
		const form = document.querySelector('.em-clinical-trials__form');
		const selects = form.querySelectorAll('select');

		selects.forEach((select) => {
			if (select.options.length > 0) {
				select.selectedIndex = 0; // Reset to first option (default)
			}
		});

		// Optionally clear other input fields if needed
		const inputs = form.querySelectorAll('input[type="text"], input[type="number"]');
		inputs.forEach((input) => input.value = '');

		// Reset URL parameters without reloading the page
		const url = new URL(window.location.href);
		url.search = ''; // Remove query parameters
		window.history.replaceState({}, document.title, url);

		// Submit the form
		form.submit();
	});
}
